<template>
  <div class="settings-item">
    <div class="settings-item__header">
      <div class="settings-item__title">
        {{ t('settings_item.label.' + (props.title || props.item.title)) }}
      </div>
      <div
        v-if="props.settings"
        v-click-outside="closeConditionMenu"
        class="settings-item__button-condition"
        @click="toggleConditionMenu"
      >
        <div
          v-if="currentCondition"
          class="settings-item__icon-condition"
        >
          <ConditionAndIcon :active="true" />
        </div>
        <div
          v-else
          class="settings-item__icon-condition"
        >
          <ConditionOrIcon :active="true" />
        </div>

        <ul
          v-if="isShowConditionMenu"
          class="settings-item__condition-list"
        >
          <li
            class="settings-item__condition-item"
            :class="{'settings-item__condition-item--active': currentCondition}"
            @click.stop="defineTitle(true)"
          >
            <div class="settings-item__condition-item-icon">
              <ConditionAndIcon :active="currentCondition" />
            </div>
            «{{ t('settings_item.button.condition_and').toUpperCase() }}»
          </li>
          <li
            class="settings-item__condition-item"
            :class="{'settings-item__condition-item--active': !currentCondition}"
            @click.stop="defineTitle(false)"
          >
            <div class="settings-item__condition-item-icon">
              <ConditionOrIcon :active="!currentCondition" />
            </div>
            «{{ t('settings_item.button.condition_or').toUpperCase() }}»
          </li>
        </ul>
      </div>
      <button
        :class="{'settings-item__button-collapse--active': isOpenList}"
        class="settings-item__button-collapse"
        @click="toggleList"
      >
        <ChevronDown />
      </button>
    </div>
    <Component
      v-bind="componentProps"
      :is="props.component"
      :is-open-list="isOpenList"
    />
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { defineProps } from "vue";
import { t } from "@/controllerLK/AvalLocalization";
import ConditionAndIcon from "@/components/Icons/ConditionAndIcon.vue";
import ConditionOrIcon from "@/components/Icons/ConditionOrIcon.vue";
import ChevronDown from "@/components/Icons/ChevronDown.vue";
import { useNewsFeedStore } from "@/store/NewsFeed/newsFeed";

const store = useNewsFeedStore();

const props = defineProps({
  title: {
    type: String,
    required: false,
    default: null
  },
  item: {
    type: Object,
    default: () => {}
  },
  component: {
    type: Object,
    default: () => {}
  },
  settings: {
    type: Boolean,
    default: false
  },
  componentProps: {
    type: Object,
    default: () => ({})
  }
});

// Функция переключения отображения меню И/ИЛИ
const toggleConditionMenu = () => {
  isShowConditionMenu.value = !isShowConditionMenu.value;
};

// Функция закрытия меню И/ИЛИ
const closeConditionMenu = () => {
  isShowConditionMenu.value = false;
};

// Функция переключения отображения содержимого категории настроек
const toggleList = () => {
  isOpenList.value = !isOpenList.value;
};

// Флаг. Отображение выпадающего списка переключения И/ИЛИ
const isShowConditionMenu = ref(false);

// Флаг. Открыто ли содержимое категории
const isOpenList = ref(true);

// Вычисляемая функция получения текущей категории для переключения И/ИЛИ.
const currentCondition = computed(() => {
  if (props.item.title === "region") {
    return store.filterRegion.condition;
  } else if (props.item.title === "tags") {
    return store.filterTags.condition;
  } else if (props.item.title === "object") {
    return store.filterObject.condition;
  }
  return true;
});

// Функция. Установка значения И/ИЛИ.
function defineTitle(value) {
  toggleConditionMenu();

  if (props.item.title === "region") {
    store.filterRegion.condition = value;
    store.filterRegion.filterList = [];
  } else if (props.item.title === "tags") {
    store.filterTags.condition = value;
  } else if (props.item.title === "object") {
    store.filterObject.condition = value;
  }
  store.clearNewsFeed();
  store.getNews();
}
</script>

<style scoped lang="scss">
.settings-item {
  display: flex;
  flex-direction: column;
  gap: 14px;

  &__condition {
    &-list {
      position: absolute;
      top: calc(100% + 2px);
      left: 0;
      background-color: var(--background-bg-white);
      box-shadow: 1px 2px 10px 0 var(--gray-gray50);
      padding: 6px;
      border-radius: 8px;
      z-index: 9999;
    }

    &-item {
      display: flex;
      align-items: center;
      gap: 5px;
      padding: 4px 14px 4px 10px;
      border-radius: 8px;
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;

      &-icon {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 24px;
        height: 20px;
        svg {
          width: 20px;
          height: 14px;
        }
      }



      &--active {
        color: var(--text-text-on);
        &:hover { background-color: var(--background-bg-active-hover) }
      }

      &:hover:not(&--active) {
        background-color: var(--background-bg-hover);
      }
    }
  }

  &__icon {
    &-condition {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 24px;
      height: 20px;
      svg {
        width: 20px;
        height: 14px;
      }
    }
  }

  &__button {
    &-collapse {
      color: var(--icon-icon-primary);
      margin-left: auto;
      background-color: transparent;
      transition: transform .2s ease-in-out;
      align-self: flex-start;

      &--active {
        transform-origin: center;
        transform: rotate(180deg);
      }
    }

    &-condition {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      width: 28px;
      height: 24px;
      border-radius: 8px;
      background-color: var(--purple-purple20);
      cursor: pointer;

      &--active {
        background-color: var(--purple-purple30);
      }

      &:hover {
        background-color: var(--purple-purple30);
      }
    }
  }

  &__title {
    color: var(--text-text-pur);
    line-height: 18px;
    font-weight: 500;
    font-size: 14px;
  }

  &__header {
    display: flex;
    align-items: center;
    gap: 6px;
  }
}
</style>
